export const mutations = {

  SET_SERVICE_ENTITY (state, { serviceId, data }) {
    let service = state.services.find(s => s.id === serviceId)
    let index = service.entities.findIndex(e => e.id === data.id)
    service.entities[index] = data
    state.loggedUser.entity = data
  },

  SET_HAS_LOADED (state, payload) {
    state.hasLoaded = payload
  },

  ADD_NEW_ENTITY (state, payload) {
    state.services.forEach(s => {
      if (s.entities) {
        s.entities.push(JSON.parse(JSON.stringify(payload)))
      }
    })
  },

  ADD_CITY_TO_ENTITIES (state, { entity, city }) {
    state.services.forEach(s => {
      if (s.entities) {
        let entityFound = s.entities.find(e => e.id === entity)
        if (entityFound) {
          entityFound.cities.push(city)
        }
      }
    })
  },

  SET_SERVICES (state, { services, entities }) {
    state.services = services.map(service => ({
      ...service,
      entities,
      icon: state.icons[service.id]
    }))
  },

  SET_REDIRECT_FROM (state, payload) {
    state.redirectFrom = payload
  },

  SET_LOGGED_USER (state, payload) {
    state.loggedUser = payload
  },

  SET_CLUSTERS (state, payload) {
    state.clusters = payload
  },

  SET_BUSINESS_PLANS (state, payload) {
    state.businessPlans = payload
  },

  SET_AUTH_TOKEN (state, payload) {
    if (Array.isArray(payload)) {
      payload.sort((a, b) => ('' + a.attr).localeCompare(b.attr))
    }
    state.authToken = payload
  },

  ADD_DYNAMIC_MODULE (state, { moduleName }) {
    state.dynamicModules.add(moduleName)
  },

  SET_ONE_CARE_TOKEN (state, token) {
    state.oneCareToken = token
  },

  SET_ONE_CARE_BASE_URL (state, url) {
    state.oneCareBaseUrl = url
  },

  SET_SHOULD_SHOW_PASSWORD_RENEWAL_WARNING (state, show) {
    state.shouldShowPasswordRenewalWarning = show
  },

  SET_REQUIRES_2FA (state, payload) {
    state.requires_2fa = payload
  }

}
